<template>
    <div id="videos">
        <v-container>
            <sectionTitle :title="title" />
                <v-layout row align-center justify-center fill-height>
                    <v-flex xs12 sm10>  

    <v-expansion-panel class="text-xs-center">
        <v-expansion-panel-content class="silver">
            <div slot="header" class="video-title">Соло</div>  
                <v-card>
                    <v-card-text>
                        <videoBlock :videos="Solos" />
                    </v-card-text>
                </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content class="silver">
            <div slot="header" class="video-title">Дуети</div>
                <v-card>
                    <v-card-text>
                        <videoBlock :videos="Duets" />
                    </v-card-text>
                </v-card>
        </v-expansion-panel-content>  

        <v-expansion-panel-content class="silver">
            <div slot="header" class="video-title">Улюблене</div>
                <v-card>
                    <v-card-text>
                        <p class="text-justify px-5">Відео з концерту "Улюблене", що відбувся 26 травня 2011 року у Колонній залі ім. М. В. Лисенка Національної філармонії України у місті Києві. У концерті брали участь заслужені артистки України, солістки Національної опери України Ірина Семененко та Анжеліна Швачка у супроводі Академічного оркестру народної та популярної музики Національної радіокомпанії України під управлінням народного артиста України Святослава Литвиненка.</p>

                         <videoBlock :videos="Favourits" />                      
                    </v-card-text>
                </v-card>
        </v-expansion-panel-content>  

        <v-expansion-panel-content class="silver">
            <div slot="header" class="video-title">"Дорогами кохання"</div>
                <v-card>
                    <v-card-text>
                       <p class="text-justify px-5"> Відео з концерту "Дорогами любові", що відбувся 13 жовтня 2012 року у Колонній залі ім. М. В. Лисенка Національної філармонії України у місті Києві. У концерті брали участь заслужені артистки України, солістки Національної опери України Ірина Семененко та Анжеліна Швачка у супроводі ансамблю народних інструментів "Рідні наспіви" під керівництвом заслуженого працівника культури України Юрія Карнауха.</p>

<p class="text-italic px-4 small secondary--text">* Нижче до вашої уваги пропонується плейлист з творами концерту.<br>Для відображення списку пісень, будь ласка, натисніть"Playlist" - лівий верхній кут відео плеєра.</p>

    <br>
        <v-layout row align-center justify-center fill-height>
            <v-flex xs12 sm8>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/_8qBjnKY2ik" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </v-flex>
        </v-layout>
    <br>
                    </v-card-text>
                </v-card>
        </v-expansion-panel-content>  

        <v-expansion-panel-content class="silver">
            <div slot="header" class="video-title">"Ми!"</div>
                <v-card>
                    <v-card-text>

 <p class="text-justify px-5">Відео з концерту "Ми", що відбувся 8 лютого 2015 року у Колонній залі ім. М. В. Лисенка Національної філармонії України у місті Києві. У концерті брали участь заслужені артистки України, солістки Національної опери України Ірина Семененко та Анжеліна Швачка у супроводі заслужених артистів України Костянтина Фесенка та Світлани Орлюк.</p>

    <br>
        <v-layout row align-center justify-center fill-height>
            <v-flex xs12 sm8>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/ZQvgwkwn68g" frameborder="0" allowfullscreen></iframe>
            </v-flex>
        </v-layout>
    <br>

                    </v-card-text>
                </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>

                </v-flex>
            </v-layout>  
        </v-container>
    </div>
</template>

<script>
    import sectionTitle from "@/components/SectionTitle";
    import solos from '@/data/solos.json'
    import duets from '@/data/duets.json'
    import favourites from '@/data/favourites.json'
    import videoBlock from '@/components/VideoBlock'

    export default {
        name: 'Videos',
        components: { sectionTitle, videoBlock },
        data() {
           return {
                title: 'Відео',
                Solo: [],
                Duets: [],
                Favourits: []
           }
        },
        created() {
            this.getVideos()
        },
        methods: {
            getVideos(){
                this.Solos = solos
                this.Duets = duets
                this.Favourits = favourites
            }
        }
    }
</script>

<style>
    #videos {
        background-color: #eee!important;
        
    }
    .silver 
    { 
        background-color:#eee!important; 
    }
</style>


